import type { BlueprintAccessibilityHiddenModifier } from '@/grove-blueprints/generated-types'

import type { ResolvedModifiers } from './resolve-modifiers'

export function resolveAccessibilityHiddenModifier(
  modifier: BlueprintAccessibilityHiddenModifier,
) {
  const attributes: ResolvedModifiers['attributes'] = {}

  if (modifier.value) {
    attributes['aria-hidden'] = true
  }

  return attributes
}
